<template>
  <v-container>
    <v-card-text>
 
      <v-col cols="12" md="4">
        <v-text-field
          class="mt-n5"
          v-model="search"
          type="text"
          placeholder="نام کسب و کار برای جستجو"
          outlined
          dense
          clearable
          label="جستجو"
          @input="fetchVendorsItems"
        />
      </v-col>
      <v-data-table
        :loading="loadingPagesTable"
        :items="vendorItems"
        :headers="VendorsHeader"
        class="elevation-1"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:[`item.logoFileUrl`]="{ item }">
          <v-img
            width="50"
            height="50"
            :src="item.logoFileUrl.thumbnailFileUrl ? item.logoFileUrl.thumbnailFileUrl : ''"
          />
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="showPage(item)">
                <v-icon color="primary" dark v-bind="attrs" v-on="on">
                  mdi-eye
                </v-icon>
              </v-btn>
            </template>
            <span>مشاهده کسب و کار در سایت تکصان</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="editVendor(item)">
                <v-icon color="primary" dark v-bind="attrs" v-on="on">
                  mdi-lead-pencil
                </v-icon>
              </v-btn>
            </template>
            <span>ویرایش</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon color="error" @click="deleteVendor(item)"
                ><v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon></v-btn
              >
            </template>
            <span>حذف</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <div class="text-center pt-5">
        <v-row>
          <v-col cols="12" sm="2" md="2">
            <v-select
              outlined
              dense
              v-model="itemsPerPage"
              :items="[5, 10, 20]"
              label="تعداد نمایش در صفحه"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="10" md="10">
            <v-pagination
              circle
              v-model="pageNumber"
              :length="vendorsCount"
              :total-visible="7"
            ></v-pagination>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-container>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
 
const enumsRepository = () => RepoFactory.get('enums');
const merchantRepository = () => RepoFactory.get('merchant');
import Helper from '@/core/helpers';
import qs from 'qs';
 

export default {
  data() {
    return {
      filterColumn: [],
      savedFilters: [],
      search: '',
      vendorItems: [],
      pageNumber: 1,
      itemsPerPage: 10,
      vendorsCount: 0,
      loadingPagesTable: true,
      VendorsHeader: [
        {
          value: 'logoFileUrl',
          text: 'لوگو  ',
          sortable: true,
        },
        {
          value: 'merchantName',
          text: 'نام کسب و  کار',
          sortable: true,
        },
         {
          value: 'vendorGroupTitle',
          text: 'گروه',
          sortable: true,
        },
        
        {
          value: 'description',
          text: 'توضیحات',
          sortable: true,
        },

        {
          value: 'actions',
          text: 'عملیات',
        },
      ],
    };
  },
  created() {
 
    //  if (this.$store.getters.currentMerchantObject.vendorManageable) {
    //   this.getVendorPermission(
    //     this.$store.getters.currentMerchantObject.vendorPermissionId
    //   );
    // }
    if (this.currentMerchant != null && this.$store.getters.currentMerchantObject.vendorManageable) {
      this.fetchVendorsItems();
    }
  },
  computed: {
    baseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    currentMerchant() {
      return this.$store.getters.currentMerchant;
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
  },
  watch: {
    currentMerchant() {
      this.fetchVendorsItems();
    },
    pageNumber() {
      this.fetchVendorsItems();
    },
    itemsPerPage() {
      this.fetchVendorsItems();
    },
    search(val) {
      if (val && val.length >= 3) {
        this.fetchVendorsItems();
      } else {
        this.fetchVendorsItems();
      }  
    },
  },
  methods: {
    getClassTypeModel() {
      enumsRepository()
        .getModel('PageListDto', this.baseUrl)
        .then((res) => {
          this.filterColumn = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    saveFilter() {
      localStorage.setItem(
        'supplierPagesFilter',
        JSON.stringify(this.$refs.advanceFillterRef.Filters)
      );
    },
  
    openCreateForm() {
      this.$store.commit('setVendorsFormStatus', true);
    },
    fetchVendorsItems() {
      let app = this;
      this.vendorItems = [];
      let params = {
        PageNumber: this.pageNumber,
        ItemsPerPage: this.itemsPerPage,
      };
      if (this.search && this.search.length > 3) {
        params.MerchantName=this.search
      }
      else {
        params.MerchantName =null
      }
      
      const loader = this.$loading.show();
      merchantRepository()
        .getVendors(
          this.$store.getters.currentMerchant,
          app.merchantBaseUrl,
          {},
          params,
          (params) => {
            return qs.stringify(params, { allowDots: true });
          }
        )
        .then((res) => {
          if (res.data.list != null) {
            this.vendorItems = res.data.list;
            this.vendorsCount = Math.ceil(
              res.data.totalCount / this.itemsPerPage
            );
          } else {
            this.vendorItems = [];
            this.vendorsCount = 1;
          }
          app.loadingPagesTable = false;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    editVendor(item) {
      
      this.$store.commit('setVendorsFormStatus', true);
      this.$store.commit('setVendorsIsEdit', true);
      this.$store.commit('setVendorsSelectedForEdit', item);
      
    },
    deleteVendor(item) {
      this.$dialog.warning({
        text: `آیا از حذف تامین کننده <span class="red--text">${item.merchantName}</span> اطمینان دارید؟`,
        title: 'هشدار',
        actions: {
          false: {
            color: 'red',
            text: 'خیر',
          },
          true: {
            color: 'primary',
            text: 'بله',
            handle: () => {
              const loader = this.$loading.show();
              merchantRepository()
                .deleteVendor(item.id, this.$store.getters.currentMerchant,
                   this.merchantBaseUrl,)
                .then((res) => {
                  this.fetchVendorsItems();
                  this.$dialog.message.success('با موفقیت حذف گردید', {
                    position: 'top-left',
                  });
                })
                .catch((error) => {
                  Helper.handleErrors(error, this);
                })
                .finally(() => loader.hide());
            },
          },
        },
      });
    },

    showPage(item) {
      let str = item.merchantName.replace(/\s+/g, '-').toLowerCase();
      let supplierUrl =
        this.$store.getters.taksaanUrl +
        '/supplier/' +
 
        item.vendorMerchantId +
         '/' +
        str;
      window.open(supplierUrl, '_blank');
    },
 
  },
   
};
</script>

<style></style>
